import { render, staticRenderFns } from "./AutomatedTestHistory.vue?vue&type=template&id=66270822&scoped=true&"
import script from "./AutomatedTestHistory.vue?vue&type=script&lang=js&"
export * from "./AutomatedTestHistory.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedTestHistory.vue?vue&type=style&index=0&id=66270822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66270822",
  null
  
)

export default component.exports